import React from 'react'
import '../CSS/BlueNav.css'

export const BlueNav = () => {
  return (
    <div className='blue-nav'>
      <div><h3>MARKET CAP</h3></div>
      <div><h3>EXCHANGE VOL</h3></div>
      <div><h3> ASSETS</h3></div>
      <div><h3>EXCHANGES</h3></div>
      <div><h3>MARKETS</h3></div>
      <div><h3>BTC DOM INDEX</h3></div>
    </div>
  )
}
